// Imports
import React, { useEffect } from 'react';
import Box from '../../../shareables/foundation/admin-ui/components/content/box';
import Heading from '../../../shareables/foundation/admin-ui/components/content/heading';
import { useAppDispatch } from '../../../shareables/foundation/front-end/redux/hooks';
import useCachedState from '../../../shareables/foundation/front-end/utils/use-cached-state';
import apiActions from '../../../shareables/integrations/api/redux/actions';
import { GetResellersResponse } from '../../../shareables/types/api/main/self/resellers/get';
import ResellerContext from './context';


// Define the accepted props
interface Props extends React.PropsWithChildren {
	storybookResellers?: GetResellersResponse;
}


// Function component
const ResellerProvider: React.FC<Props> = ({ children, storybookResellers }) => {
	// Use state
	const [resellers, setResellers] = useCachedState<GetResellersResponse | null>(
		storybookResellers ?? null,
		'resellers'
	);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load reseller on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetResellersResponse>({
				action: 'GET',
				uri: '/self/resellers',
				completion: (json) => {
					setResellers(json.response);
				},
			})
		);
	}, [dispatch, setResellers]);
	
	
	// If loading resellers, then display nothing
	if (resellers === null) {
		return null;
	}
	
	
	// Handle no resellers
	if (resellers.length === 0) {
		return (
			<React.Fragment>
				<Heading size={1}>No reseller available</Heading>
				
				<Box>It looks like you’re not associated with a reseller.</Box>
			</React.Fragment>
		);
	}
	
	
	// Return JSX
	return <ResellerContext.Provider value={{ ...resellers[0] }}>{children}</ResellerContext.Provider>;
};

export default ResellerProvider;
